import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-20 md:py-32 bg-sage/30" data-id="element-172">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-173">
        <FadeIn data-id="element-174">
          <p className="font-serif text-2xl md:text-3xl lg:text-4xl leading-relaxed text-teal" data-id="element-175">
            "Son las 7 de la mañana y el jean que antes te quedaba perfecto hoy
            no cierra. O peor, cierra, pero sabés que para las 4 de la tarde la
            presión en tu abdomen va a ser insoportable."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-176">
          <div className="w-12 h-[1px] bg-gold mx-auto my-10" data-id="element-177"></div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-178">
          <p className="text-lg text-teal/80 leading-relaxed font-light max-w-2xl mx-auto" data-id="element-179">
            No es solo peso; es una pesadez que te nubla el día. Sentís que tu
            cuerpo cambió las reglas del juego. Comés sano, te movés, pero la
            balanza no baja y el espejo te devuelve una imagen que no reconocés.{' '}
            <br data-id="element-180" />
            <br data-id="element-181" />
            <span className="font-medium text-teal" data-id="element-182">
              La realidad es que después de los 40, tu cuerpo no está fallando,
              está inflamado.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}